import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text/text';
import {EntityCard} from '@Components/ai-chat-window/components/entity-card/entity-card';
import type {EntityCardGroupProps} from './entity-card-group.types';
import styles from './entity-card-group.module.scss';

export function EntityCardGroup({title, cards}: EntityCardGroupProps): ReactElement {
  const groupLabel = title !== undefined && title !== '' ? title : window.i18next.t('pmwjs_ai_chat_card_group');

  const renderTitle = (): ReactElement | null => {
    if (title === undefined || title === '') {
      return null;
    }

    return <Text val={title} size={TextSize.MD} bold className={styles.entityCardGroupTitle} />;
  };

  return (
    <div className={styles.entityCardGroup}>
      {renderTitle()}
      <ul className={styles.entityCardList} role="list" aria-label={groupLabel}>
        {cards.map((card, index) => (
          <li key={`${card.title ?? ''}-${index}`} className={styles.entityCardItem}>
            <EntityCard {...card} />
          </li>
        ))}
      </ul>
    </div>
  );
}
